export enum AcquirerTypes {
  MAYA = 1,
  AUB = 2,
  UNIONBANK = 3,
}

export interface IBusinessAcquirerType {
  id: AcquirerTypes;
  type: string;
}
